import { useState } from 'react';
import SideDrawer from '../../components/side-drawer';
import { ReportFilters } from './components';
import ReportCard from './components/ReportCard';
import {
  lmsModuleReports,
  reportsAdmin,
  shippingModuleReports,
} from './constants';

interface Props {
  isAdmin?: boolean;
  isLms?: boolean;
}

export default function Reports({ isAdmin = false, isLms = false }: Props) {
  const [selectedReportTitle, setSelectedReportTitle] = useState<string>('');
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [selectedReportType, setSelectedReportType] = useState<any>('');

  let reportPopulate = isAdmin
    ? reportsAdmin
    : isLms
    ? lmsModuleReports
    : shippingModuleReports;

  const closeSideDrawer = () => {
    setIsDrawerOpen(false);
  };

  const handleViewVilterClick = (clickedType: any, clickedTitle: string) => {
    setSelectedReportType(clickedType);
    setSelectedReportTitle(clickedTitle);
    setIsDrawerOpen(true);
  };

  return (
    <>
      <div className='container-fluid my-4'>
        <div className='d-flex flex-column gap-4 justify-content-start'>
          {reportPopulate.map((report) => {
            return (
              <ReportCard
                key={report.title}
                title={report.title}
                description={report.description}
                type={report.type}
                onViewFilter={handleViewVilterClick}
              />
            );
          })}
        </div>
      </div>
      <SideDrawer
        title={selectedReportTitle}
        isOpen={isDrawerOpen}
        onClose={closeSideDrawer}
      >
        <ReportFilters
          isAdmin={isAdmin}
          reportType={selectedReportType}
        />
      </SideDrawer>
    </>
  );
}
